import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { LogIn, Loader2, ShieldCheck } from 'lucide-react';
import { adminLogin } from '../lib/api';
import { toast } from '../hooks/use-toast';
import { LOGO_URL } from '../mock/mock';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      localStorage.setItem('wyw_admin_token', res.token);
      localStorage.setItem('wyw_admin_email', res.email);
      toast({ title: 'Welcome back', description: 'Signed in as admin.' });
      navigate('/admin');
    } catch (err) {
      toast({
        title: 'Login failed',
        description: err?.response?.data?.detail || 'Invalid credentials',
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#FAF6F1] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center mb-6">
          <img src={LOGO_URL} alt="Wrap Your Wish" className="h-16 w-auto" />
        </Link>
        <div className="bg-white rounded-2xl border border-[#EFE3D2] p-8 md:p-10">
          <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-[#C58B76] mb-3">
            <ShieldCheck className="w-4 h-4" /> Admin Console
          </div>
          <h1 className="font-serif-display text-3xl text-[#2C2416]">Welcome back</h1>
          <p className="text-sm text-[#5B4A3A] mt-1">Sign in to manage enquiries and hampers.</p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="block text-xs uppercase tracking-widest text-[#7A5C4C] mb-2">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@wrapyourwish.com"
                className="w-full bg-white border border-[#E4D6C1] rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-[#C58B76] focus:ring-2 focus:ring-[#F4D5C5]" />
            </div>
            <div>
              <label className="block text-xs uppercase tracking-widest text-[#7A5C4C] mb-2">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full bg-white border border-[#E4D6C1] rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-[#C58B76] focus:ring-2 focus:ring-[#F4D5C5]" />
            </div>
            <button type="submit" disabled={loading}
              className="btn-primary w-full rounded-full py-3 text-xs uppercase tracking-widest inline-flex items-center justify-center gap-2 disabled:opacity-60">
              {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Signing in</> : <><LogIn className="w-4 h-4" /> Sign In</>}
            </button>
          </form>
        </div>
      </div>
    </main>
  );
};

export default AdminLogin;
